export default __webpack_public_path__ + "static/media/alur-box-3.ee40f2c4.png";